import { render, staticRenderFns } from "./AsociarProveedor.vue?vue&type=template&id=7ca16142&"
import script from "./AsociarProveedor.vue?vue&type=script&lang=ts&"
export * from "./AsociarProveedor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports